import React from 'react'
import {
    KpisDrillingRealTimeHeaderTitleRegistryService,
    KpisDrillingRealTimeSectionRowRegistryService,
    KpisDrillingRealTimeSectionRowStatusRegistryService,
    KpisDrillingReprocessHeaderTitleRegistryService,
    KpisDrillingReprocessSectionRowRegistryService,
    KpisDrillingReprocessSectionRowStatusRegistryService
} from 'plugin-kpis-drilling/shared/services/KpisDrillingRegistry'

import './utils/dayjsSetup'
import { addi18n } from '../i18n'
import { RealtimeRigFloorSelectMethodoly } from './components/Realtime/RealtimeRigFloorSelectMethodoly'
import { RealtimeRigFloorKpis } from './components/Realtime/RealtimeRigFloorKpis'
import { RealtimeRigFloorStatusComponent } from './components/Realtime/RealtimeRigFloorStatusComponent'
import { ReprocessRigFloorSelectMethodoly } from './components/Reprocess/ReprocessRigFloorSelectMethodoly'
import { ReprocessRigFloorStatusComponent } from './components/Reprocess/ReprocessRigFloorStatusComponent'
import ReprocessRigFloorKpis from './components/Reprocess/ReprocessRigFloorKpis'

import liveUiService from 'live/services/ui'
import AddOnImpl from 'live/api/add-on'

import { withSuspenseWrapper } from './components/SuspenseWrapper'

const WrapperSelectKpisFilter = withSuspenseWrapper(React.lazy(() => import('./widgets/filters/selectKpisFilter')))
const WrapperRiserSelectKpisFilter = withSuspenseWrapper(
    React.lazy(() => import('./widgets/filters/riserSelectKpisFilter'))
)

liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
    new AddOnImpl(WrapperSelectKpisFilter, { order: -20 })
)
liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
    new AddOnImpl(WrapperRiserSelectKpisFilter, { order: -20 })
)

require('./widgets')

// Adding the translation
addi18n()

// Components for Realtime extension point
const componentRealTimeHeaderTitle = {
    id: 'kpi-rig-floor-component-realtime-header-title',
    Component: RealtimeRigFloorSelectMethodoly
}
if (KpisDrillingRealTimeHeaderTitleRegistryService.registry) {
    KpisDrillingRealTimeHeaderTitleRegistryService.registry.register(componentRealTimeHeaderTitle)
}

const componentRealTimeSectionRow = {
    id: 'kpi-rig-floor-component-realtime-section-row',
    Component: RealtimeRigFloorKpis
}
if (KpisDrillingRealTimeSectionRowRegistryService.registry) {
    KpisDrillingRealTimeSectionRowRegistryService.registry.register(componentRealTimeSectionRow)
}

const componentRealTimeRowStatus = {
    id: 'kpi-rig-floor-component-realtime-row-status',
    Component: RealtimeRigFloorStatusComponent
}
if (KpisDrillingRealTimeSectionRowStatusRegistryService.registry) {
    KpisDrillingRealTimeSectionRowStatusRegistryService.registry.register(componentRealTimeRowStatus)
}

// Components for Reprocess extension point
const componentReprocessHeaderTitle = {
    id: 'kpi-rig-floor-component-reprocess-header-title',
    Component: ReprocessRigFloorSelectMethodoly
}
if (KpisDrillingReprocessHeaderTitleRegistryService.registry) {
    KpisDrillingReprocessHeaderTitleRegistryService.registry.register(componentReprocessHeaderTitle)
}

const componentReprocessSectionRow = {
    id: 'kpi-rig-floor-component-reprocess-section-row',
    Component: ReprocessRigFloorKpis
}
if (KpisDrillingReprocessSectionRowRegistryService.registry) {
    KpisDrillingReprocessSectionRowRegistryService.registry.register(componentReprocessSectionRow)
}

const componentReprocessRowStatus = {
    id: 'kpi-rig-floor-component-reprocess-row-status',
    Component: ReprocessRigFloorStatusComponent
}
if (KpisDrillingReprocessSectionRowStatusRegistryService.registry) {
    KpisDrillingReprocessSectionRowStatusRegistryService.registry.register(componentReprocessRowStatus)
}
